import { hasExactRoutePermission } from "./permissions";

const POS_ADMIN_ROUTE_PRIORITY = {
  TABLE_DINE_IN: [
    "/floorplan/floors",
    "/menu/items",
    "/devices/health",
    "/settings/fulfillment",
    "/settings/faq",
  ],
  DINE_IN: [
    "/menu/items",
    "/floorplan/floors",
    "/devices/health",
    "/settings/fulfillment",
    "/settings/faq",
  ],
  DEFAULT: [
    "/menu/items",
    "/devices/health",
    "/settings/fulfillment",
    "/settings/faq",
    "/floorplan/floors",
  ],
};

const getPosAdminRoutePriority = (posDineInMode) => {
  const normalizedMode = String(posDineInMode || "").trim().toUpperCase();
  return POS_ADMIN_ROUTE_PRIORITY[normalizedMode] || POS_ADMIN_ROUTE_PRIORITY.DEFAULT;
};

export const getPosAdminDestination = (user, posDineInMode) => {
  const candidateRoutes = getPosAdminRoutePriority(posDineInMode);
  return candidateRoutes.find((pathname) => hasExactRoutePermission(user, pathname)) || null;
};

export const hasPosAdminAccess = (user, posDineInMode) =>
  Boolean(getPosAdminDestination(user, posDineInMode));
